/**
 * AdminSupportInboxPage — /admin/support-inbox
 *
 * Wraps SupportInboxPanel with the standard admin shell + auth guard.
 */
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { AppShell } from '../components/Layout';
import { Button } from '../components/ui/button';
import { ArrowLeft, Mail } from 'lucide-react';
import { useAuth } from '../lib/auth-context';
import SupportInboxPanel from '../components/admin/SupportInboxPanel';

export default function AdminSupportInboxPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/dashboard" replace />;

  return (
    <AppShell>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/admin')}
          className="-ml-2 gap-1.5"
          data-testid="support-inbox-back"
        >
          <ArrowLeft size={14} /> Back to admin
        </Button>
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-sky-100 text-sky-800 dark:bg-sky-500/15 dark:text-sky-300 px-3 py-1 text-[11px] font-mono-edge tracking-[0.16em] uppercase">
            <Mail size={12} /> Support Inbox
          </div>
          <h1 className="mt-3 text-3xl font-bold text-foreground">help@blayzrr.com</h1>
          <p className="text-muted-foreground mt-1">
            Every reply to a Blayzrr email — and every direct message to <b>help@blayzrr.com</b> — lands here via Resend Inbound.
            Reply from inside a thread and the message goes back via Resend outbound with the right subject + reply-to.
          </p>
        </div>
        <SupportInboxPanel />
      </div>
    </AppShell>
  );
}
